import { render, staticRenderFns } from "./ExternalPaidOrderBindPage.vue?vue&type=template&id=3349043c&scoped=true"
import script from "./ExternalPaidOrderBindPage.vue?vue&type=script&lang=js"
export * from "./ExternalPaidOrderBindPage.vue?vue&type=script&lang=js"
import style0 from "./ExternalPaidOrderBindPage.vue?vue&type=style&index=0&id=3349043c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349043c",
  null
  
)

export default component.exports